<div class="tree-wrapper" style="height: 450px;">
    <div *ngIf="isDataLoading" class="d-loading">
        <div class="loader">Loading ...</div>
    </div>
    <p class="p-5 text-center" *ngIf="!isDataLoading && !nodes.length" >
        No documents available.
    </p>
    <input (keyup)="filterDocuments($event.target.value)"
           *ngIf="!isDataLoading && nodes.length"
           class="form-control my-2 w-25"
           placeholder="Search"/>
    <tree-root #tree [nodes]="filteredNodes" [options]="options">
        <ng-template #treeNodeWrapperTemplate let-index="index" let-node>
            <div [style.padding-left]="node.getNodePadding()" class="node-wrapper">
                <label class="tree-checkbox">
                    <input (change)="node.toggleActivated(); checkFile(node.data, !node.data.checked);" [checked]="node.data.checked" class="custom-checkbox"
                           type="checkbox"/>
                    <span style="margin-top: 6px;"></span>
                </label>
                <tree-node-expander [node]="node"></tree-node-expander>
                <div (click)="node.mouseAction('click', $event);"
                     (contextmenu)="node.mouseAction('contextMenu', $event)"
                     (dblclick)="node.mouseAction('dblClick', $event)"
                     (treeDrop)="node.onDrop($event)"
                     [class.node-content-wrapper-active]="node.isActive"
                     [class.node-content-wrapper-focused]="node.isFocused"
                     [treeAllowDrop]="false"
                     [treeDragEnabled]="false"
                     [treeDrag]="node"
                     class="node-content-wrapper">

                    <img [src]="'/assets/images/payhoa/sharedMedia/' + node.data.icon + '.svg'" class="file-icon"/>
                    <span>{{node.displayField}}</span>
                </div>
            </div>
        </ng-template>
    </tree-root>
</div>
